import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7aa410b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = {
  class: "panel-body",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_6 = { style: {"min-width":"90px","min-height":"90px"} }
const _hoisted_7 = ["src"]
const _hoisted_8 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Seria.", -1))
const _hoisted_10 = {
  class: "text__title--medium",
  style: {"padding-left":"5px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Nr.", -1))
const _hoisted_12 = {
  class: "text__title--medium",
  style: {"padding-left":"5px"}
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = {
  class: "col-md-7",
  style: {"padding-right":"5px"}
}
const _hoisted_15 = { class: "table table-nocondensed" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Status:"),
    /*#__PURE__*/_createElementVNode("span", {
      class: "material-icons",
      style: {"margin-left":"auto"}
    }, "create")
  ])
], -1))
const _hoisted_17 = { class: "text__input--medium bg-white" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Furnizor: ", -1))
const _hoisted_19 = { class: "text__input--medium bg-white" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Cont Furnizor:")
  ])
], -1))
const _hoisted_21 = { class: "text__input--medium bg-white" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Cumparator: ", -1))
const _hoisted_23 = { class: "text__input--medium bg-white" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Cont Cumparator:")
  ])
], -1))
const _hoisted_25 = { class: "text__input--medium bg-white" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Moneda:")
  ])
], -1))
const _hoisted_27 = { class: "text__input--medium bg-white" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Data eliberare: ", -1))
const _hoisted_29 = { class: "text__input--medium bg-white" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Data termen: ", -1))
const _hoisted_31 = { class: "text__input--medium bg-white" }
const _hoisted_32 = {
  class: "col-md-5",
  style: {"padding-left":"2em","display":"flex","flex-direction":"column","justify-content":"center","align-items":"flex-start"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total TVA: ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total NET: ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total Factura: ", -1))
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%","border-bottom":"1px solid black"} }, null, -1))
const _hoisted_38 = { style: {"display":"flex","align-items":"left","justify-content":"left","width":"100%"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Articole/servicii")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = { style: {"display":"flex","justify-content":"center","width":"100%"} }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Editeaza", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Editeaza", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Adaugare articol sau serviciu", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_popup_edit = _resolveComponent("q-popup-edit")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_EditArticolFactura = _resolveComponent("EditArticolFactura")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingFacturaData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", { src: _ctx.getLinkToQrCode }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                  }, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.factura.seria), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                  }, [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.factura.nr), 1)
                  ], 2),
                  _createVNode(_component_q_btn, {
                    color: "white",
                    "text-color": "black",
                    "icon-right": "print",
                    label: "Tipareste!",
                    disable: _ctx.loadingPdfForDownload,
                    "no-caps": "",
                    loading: _ctx.loadingPdfForDownload,
                    onClick: _ctx.prepareCoverPdfForDownload
                  }, {
                    loading: _withCtx(() => [
                      _createVNode(_component_q_spinner_gears, { class: "on-right" }),
                      _createTextVNode(" Pregatire... ")
                    ]),
                    _: 1
                  }, 8, ["disable", "loading", "onClick"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_16,
                      _createElementVNode("td", _hoisted_17, [
                        _createTextVNode(_toDisplayString(_ctx.getDenStatus(_ctx.factura.stare)) + " ", 1),
                        _createVNode(_component_q_popup_edit, {
                          modelValue: _ctx.factura.stare,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.factura.stare) = $event)),
                          validate: val => val.length > 0
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_q_select, {
                              outlined: "",
                              modelValue: scope.value,
                              "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                              options: _ctx.optionsStatus,
                              style: {"min-width":"300px"},
                              "option-value": "value",
                              "option-label": "label",
                              "emit-value": "",
                              "map-options": "",
                              "lazy-rules": "",
                              dense: "",
                              autofocus: "",
                              hint: "Modificare stare",
                              "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                              rules: [val => val && val.length > 0 || 'Alegeti tipul de stare!']
                            }, {
                              after: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  dense: "",
                                  color: "negative",
                                  icon: "cancel",
                                  onClick: _withModifiers(scope.cancel, ["stop"])
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  dense: "",
                                  color: "positive",
                                  icon: "check_circle",
                                  onClick: _withModifiers(($event: any) => (_ctx.tryUpdateStatus(scope)), ["stop"]),
                                  disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                }, null, 8, ["onClick", "disable"])
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "options", "rules"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "validate"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_18,
                      _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.furnizor.denumire, _ctx.furnizor.adresa), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_20,
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.contFurnizor.iban), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_22,
                      _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.cumparator.denumire, _ctx.cumparator.adresa), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_24,
                      _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.contCumparator.iban), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_26,
                      _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.factura.moneda), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_28,
                      _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.displayData(_ctx.factura.data_eliberare as string)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_30,
                      _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.displayData(_ctx.dataTermen)), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", null, [
                  _hoisted_33,
                  _createElementVNode("span", null, _toDisplayString(_ctx.totalTvaFormated), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_34,
                  _createElementVNode("span", null, _toDisplayString(_ctx.totalNetFormated), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_35,
                  _createElementVNode("span", null, _toDisplayString(_ctx.totalFacturaFormated), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    flat: "",
                    color: "primary",
                    icon: "add_box",
                    "no-caps": "",
                    disable: _ctx.loadingFacturaData,
                    onClick: _ctx.openFormFacturaArticol
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, {
                        "transition-show": "rotate",
                        "transition-hide": "rotate"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Adaugare articol sau serviciu nou ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disable", "onClick"])
                ]),
                _hoisted_40
              ]),
              _createElementVNode("div", _hoisted_41, [
                (_ctx.loadingFacturaArticole)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 0,
                      color: "primary",
                      size: "3em",
                      thickness: 10
                    }))
                  : (_openBlock(), _createBlock(_component_q_table, {
                      key: 1,
                      dense: "",
                      "rows-per-page-options": [0],
                      rows: _ctx.facturaArticole,
                      columns: _ctx.facturaArticoleListColumns,
                      "visible-columns": _ctx.visibleFacturaArticoleListColumns,
                      "row-key": "appid",
                      filter: _ctx.filterFacturaArticoleList,
                      loading: _ctx.loadingFacturaArticole,
                      pagination: _ctx.myPagination,
                      class: "table table-bordered table-condensed table-responsive"
                    }, {
                      top: _withCtx(() => [
                        _createVNode(_component_q_space),
                        _createVNode(_component_q_input, {
                          dense: "",
                          debounce: "300",
                          color: "primary",
                          modelValue: _ctx.filterFacturaArticoleList,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterFacturaArticoleList) = $event))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "search" })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      body: _withCtx((props) => [
                        _createVNode(_component_q_tr, { props: props }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_td, {
                              key: "appid",
                              props: props,
                              sortable: false
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: 'edit',
                                  class: _normalizeClass('text-blue cursor-pointer pencil'),
                                  style: {"font-size":"1.2rem","margin-left":"auto"},
                                  onClick: ($event: any) => (_ctx.onPressEditRowFacturaArticol(props.row))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [
                                        _hoisted_42
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_q_icon, {
                                  name: 'delete',
                                  class: _normalizeClass('text-red cursor-pointer pencil'),
                                  style: {"font-size":"1.2rem","margin-left":"auto"},
                                  onClick: ($event: any) => ((_ctx.askIfRemoveFacturaArticol(props.row)))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [
                                        _hoisted_43
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "denumire",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word","max-width":"150pt"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.denumire), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "unitate_masura",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.unitate_masura), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "cantitate",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.cantitate), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "pret_fara_tva",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.pret_fara_tva), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "tva",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.tva + ' %'), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"])
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      _: 1
                    }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"]))
              ])
            ])
          ])
        ])),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.visibleDialogFacturaArticole,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visibleDialogFacturaArticole) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"80vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "add_box" }),
                _hoisted_44,
                _createVNode(_component_q_space),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "close"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_EditArticolFactura, {
                  frenunt: _ctx.renuntEditareFacturaArticol,
                  fonsave: _ctx.getFacturaArticole,
                  appid_factura: _ctx.factura.appid,
                  appid: _ctx.appid_factura_articol
                }, null, 8, ["frenunt", "fonsave", "appid_factura", "appid"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}